import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import config from 'constants/config'
import NewBedbankOfferTileExpanded from './RedesignedSearchTiles/NewBedbankOfferTileExpanded'
import NewBedbankOfferTileCondensed from './RedesignedSearchTiles/NewBedbankOfferTileCondensed'
import { useBedbankRoomRatePromotions } from 'hooks/OfferPage/useBedbankPromotions'
import moment from 'moment'

const Root = styled(Pane)`
  position: relative;
`

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary;
  filters?: App.OfferListFilters;
  eagerLoadFirstImage?: boolean;
  offerUrl: string;
  offerMetaData: App.OfferListMetaData;
}

function SearchBedbankOffer(props: Props) {
  const { offer, filters, eagerLoadFirstImage, offerUrl, offerMetaData } = props

  const promotions = useBedbankRoomRatePromotions(offer.promotions, moment(filters?.checkIn), moment(filters?.checkOut))
  const hasValidPromotions = offerMetaData?.hasPromotions || !!Object.values(promotions).length

  const showExpandedTile = config.BEDBANK_EXPANDED_SEARCH_OFFER_TILE_ENABLED && hasValidPromotions

  return <Root type="clean">
    {showExpandedTile && <NewBedbankOfferTileExpanded
       offer={offer }
       filters={filters}
       eagerLoadFirstImage={eagerLoadFirstImage}
       offerUrl={offerUrl}
      />}
    {!showExpandedTile && <NewBedbankOfferTileCondensed
      offer={offer }
      filters={filters}
      eagerLoadFirstImage={eagerLoadFirstImage}
      offerUrl={offerUrl}
    />}
  </Root>
}

export default SearchBedbankOffer
